import { CepIntegration } from 'common/api'

const INTEGRATION_NAME_REGEX = /^[0-9a-zA-Z\s\-_']+$/

const validateIntegrationName = (
  name: string,
  unavailableNames: string[] = []
) => {
  const hasInvalidCharacters =
    name.length && INTEGRATION_NAME_REGEX.test(name.toString()) === false
  const isTaken = unavailableNames?.includes(name)

  return {
    isValid: !hasInvalidCharacters && !isTaken,
    error: hasInvalidCharacters
      ? 'Jacquard only accepts letters, numbers, spaces, hyphens, apostrophes and underscores in Integration names.'
      : isTaken
      ? 'This name already exists within your account.'
      : undefined,
  }
}

export const validateName = (
  value: string | undefined,
  accountsIntegration?: CepIntegration[]
) => {
  if (!value) {
    return 'Please enter the integration name.'
  }
  const integrationNames = accountsIntegration?.map(
    (integration) => integration.name
  )
  const { error } = validateIntegrationName(value, integrationNames)
  return error
}

export const validateTestingMethod = (value: string | undefined) => {
  if (!value) {
    return 'Please select a testing method.'
  }
}

export const validateDistributionChannel = (value: string | undefined) => {
  if (!value) {
    return 'Please select a distribution channel.'
  }
}

export const validateDistributionType = (value: string | undefined) => {
  if (!value) {
    return 'Please select a distribution type.'
  }
}

export const validateIntegrationCredentials = (value: string | undefined) => {
  if (!value) {
    return 'Please enter the credentials.'
  }
}
